module.exports = __webpack_public_path__ + "img/melvin_caldenhove.bccc556b.jpg";